import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { useOrderContext } from '../../../../hooks/useContexts';
import { BodfsDatePicker } from './BodfsDatePicker';
import { BodfsDateTiles } from './BodfsDateTiles';
import { BodfsDeliveryInstructions } from './BodfsDeliveryInstructions';
import { AlertBanner } from '../../../shared/alert-banner/AlertBanner';
export var BodfsDeliveryDetails = function () {
    var _a = useOrderContext(), showCalendar = _a.showCalendar, selectedDeliverySlot = _a.selectedDeliverySlot;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "sui-pb-4" },
            React.createElement(AlertBanner, { status: "info" },
                React.createElement("div", { className: "sui-flex sui-space-x-1" },
                    React.createElement(Typography, { weight: "bold" }, "Your Delivery Cost:"),
                    (selectedDeliverySlot === null || selectedDeliverySlot === void 0 ? void 0 : selectedDeliverySlot.deliveryCharge) &&
                        (selectedDeliverySlot === null || selectedDeliverySlot === void 0 ? void 0 : selectedDeliverySlot.deliveryCharge) !== '0.00' ? (React.createElement(Typography, { weight: "bold" },
                        "$", selectedDeliverySlot === null || selectedDeliverySlot === void 0 ? void 0 :
                        selectedDeliverySlot.deliveryCharge)) : (React.createElement(Typography, { color: "success", weight: "bold" }, "FREE"))))),
        React.createElement(BodfsDateTiles, null),
        showCalendar && React.createElement(BodfsDatePicker, null),
        React.createElement(BodfsDeliveryInstructions, null)));
};
